import { Typography } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { TabularDataCell } from "../../../../../../api/types/svTypes";
import { type AgingDetailGridRow, FIRST_COLUMN_GUID } from "./AgingDetailTable.types";

interface Props {
  params: GridRenderCellParams<AgingDetailGridRow>;
  isMeasure: boolean;
  onDrillDown?: (cell: TabularDataCell) => void;
}
const DataCell = ({ params, isMeasure, onDrillDown }: Props) => {
  const cell = params.value as TabularDataCell | null;
  const formatted = cell?.formattedValue || "-";

  if (params.field === FIRST_COLUMN_GUID) {
    return (
      <Typography variant="body1" sx={{ ml: 7 }}>
        {formatted}
      </Typography>
    );
  }

  if (!isMeasure) {
    return <TypographyTooltipEllipsis text={formatted} typographyProps={{ variant: "body1" }} />;
  }

  const canDrillDown = !!cell?.drillDownId;
  return (
    <Typography
      variant="body1"
      sx={{ ...(canDrillDown ? { cursor: "pointer", "&:hover": { textDecoration: "underline" } } : {}) }}
      onClick={() => canDrillDown && cell && onDrillDown?.(cell)}
    >
      {formatted}
    </Typography>
  );
};

export default DataCell;
